import React from 'react';

import StarsRewardList from '@swf/components/StarsRewardList/StarsRewardList';
// eslint-disable-next-line import/order
import StarsCoinBalance from '@swf/components/StarsCoinBalance/StarsCoinBalance';
import type { StarsCoinReward } from '@swf/core/types/StarsCoinReward';
import { Category } from '@swf/core/types/StarsCoinReward';

import Container from '../Container/Container';
import type WithClose from '../WithClose';

import styles from './Rewards.scss';

interface Props extends WithClose {
  rewards?: StarsCoinReward[];
}

const Rewards: React.FC<Props> = ({ close, rewards = [] }) => (
  <Container
    category={Category.Rewards}
    close={close}
    right={<StarsCoinBalance className={styles.balance} />}
  >
    <StarsRewardList showCollect={false} rewards={rewards} />
  </Container>
);

export default Rewards;
